import React, { memo } from 'react'
import { LoginWrapper } from './css'
import login_left from '@/assets/images/login_left.png'
import LoginForm from './components/LoginForm'

const Download = memo(() => {
  return (
    <LoginWrapper>
      <div className="login_content">
        <div className="left">
          <img src={login_left} alt="img" />
        </div>
        <div className="right">
          <LoginForm />
        </div>
      </div>
    </LoginWrapper>
  )
})

export default Download
